var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CustomModal",
    {
      staticClass: "basic-modal chapter-edit-modal",
      attrs: {
        id: "chapter-edit-modal",
        "ok-disabled": _vm.saveDisabled,
        "ok-busy": _vm.busy,
        "ok-title": _vm.$t("common.save")
      },
      on: {
        cancel: function($event) {
          return _vm.$emit("cancel")
        },
        ok: function($event) {
          return _vm.save()
        }
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "chapter-edit-modal__title",
          attrs: { slot: "modal-header" },
          slot: "modal-header"
        },
        [_vm._v("\n    " + _vm._s(_vm.modalTitle) + "\n  ")]
      ),
      _vm._v(" "),
      _vm.loading
        ? _c(
            "div",
            { staticClass: "text-center" },
            [
              _c("LoadingBounce"),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "typography--body-2 typography--color-disabled pb-5"
                },
                [
                  _vm._v(
                    "\n      " + _vm._s(_vm.$t("common.loading")) + "\n    "
                  )
                ]
              )
            ],
            1
          )
        : _c("div", { staticClass: "chapter-edit-modal__form" }, [
            _c("div", { staticClass: "form-group" }, [
              _c(
                "label",
                {
                  staticClass:
                    "typography--body-3 typography--color-secondary typography--font-weight-600",
                  attrs: { for: "chapter-title-input" }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("publishers.modal.chapter_edit.name")) +
                      "\n      "
                  )
                ]
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.chapterTitle,
                    expression: "chapterTitle"
                  }
                ],
                staticClass: "form-control",
                attrs: {
                  type: "text",
                  id: "chapter-title-input",
                  placeholder: _vm.$t(
                    "publishers.modal.chapter_edit.name_placeholder"
                  )
                },
                domProps: { value: _vm.chapterTitle },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.chapterTitle = $event.target.value
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c(
                "label",
                {
                  staticClass:
                    "typography--body-3 typography--color-secondary typography--font-weight-600",
                  attrs: { for: "domain-select" }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("publishers.modal.chapter_edit.domain")) +
                      "\n      "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.selected.domainId,
                      expression: "selected.domainId"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: {
                    id: "domain-select",
                    disabled: _vm.filteredDomains.length === 0
                  },
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.selected,
                        "domainId",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    }
                  }
                },
                [
                  _c(
                    "option",
                    { attrs: { disabled: "" }, domProps: { value: null } },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t(
                              "publishers.modal.chapter_edit.domain_placeholder"
                            )
                          ) +
                          "\n        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.filteredDomains, function(domain) {
                    return _c(
                      "option",
                      { key: domain.id, domProps: { value: domain.id } },
                      [
                        _vm._v(
                          "\n          " + _vm._s(domain.name) + "\n        "
                        )
                      ]
                    )
                  })
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c(
                "label",
                {
                  staticClass:
                    "typography--body-3 typography--color-secondary typography--font-weight-600",
                  attrs: { for: "core-concept-select" }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.$t("publishers.modal.chapter_edit.core_concept")
                      ) +
                      "\n      "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.selected.coreConceptId,
                      expression: "selected.coreConceptId"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: {
                    id: "core-concept-select",
                    disabled: _vm.filteredCoreConepts.length === 0
                  },
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.selected,
                        "coreConceptId",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    }
                  }
                },
                [
                  _c(
                    "option",
                    { attrs: { disabled: "" }, domProps: { value: null } },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t(
                              "publishers.modal.chapter_edit.core_concept_placeholder"
                            )
                          ) +
                          "\n        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.filteredCoreConepts, function(cc) {
                    return _c(
                      "option",
                      { key: cc.id, domProps: { value: cc.id } },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(cc.name) +
                            " (" +
                            _vm._s(cc.description) +
                            ")\n        "
                        )
                      ]
                    )
                  })
                ],
                2
              )
            ])
          ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3868149e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3868149e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/publishers/components/ChapterEditModal.vue
// module id = i9WJ
// module chunks = 1